module.exports = __webpack_public_path__ + "static/media/ZCOOL Addict Italic-01.fdd6c2b9.svg";